import { render, staticRenderFns } from "./pricing-card.vue?vue&type=template&id=44fbdf64&scoped=true&"
import script from "./pricing-card.vue?vue&type=script&lang=js&"
export * from "./pricing-card.vue?vue&type=script&lang=js&"
import style0 from "./pricing-card.vue?vue&type=style&index=0&id=44fbdf64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fbdf64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCol,VIcon})
